module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ka":{"submit":"შენახვა","successMessage":"ახალი პაროლი წარმატებით შეინახა","currentPassword":"არსებული პაროლი","newPassword":"ახალი პაროლი","password_confirm":"გაიმეორე პაროლი","change-password":"პაროლის შეცვლა"}}')
  delete Component.options._Ctor
}
